import actions from '../actions';

const isSuccessApiAction = key => action =>
  action.type === actions.API_ACTION_SUCCEEDED && action.payload.key === key;

const isCompletionAction = action =>
  action.type === actions.API_ACTION_SUCCEEDED ||
  action.type === actions.API_ACTION_FAILED;

const hasApiActionStoppedLoading = key => action => {
  return isCompletionAction(action) && action.payload.key === key;
};

export {isSuccessApiAction, isCompletionAction, hasApiActionStoppedLoading};
